import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBUvLTfVzROSqWjj5Zrpyy1dhqgO_A1n0k",
  authDomain: "homee-7b3e9.firebaseapp.com",
  databaseURL: "https://homee-7b3e9-default-rtdb.firebaseio.com",
  projectId: "homee-7b3e9",
  storageBucket: "homee-7b3e9.appspot.com",
  messagingSenderId: "82774553568",
  appId: "1:82774553568:web:d73230a9e733ab5f6bb185"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);


if (window.location.hostname === "localhost") {
  auth.settings.appVerificationDisabledForTesting = true;
}
export default app;

